export interface AdminViewConfig {
  showLeftMenu: boolean,
  inMenu: boolean;
  inManagementMenu: boolean;
}

export const viewConfigDefault: AdminViewConfig = {
  inManagementMenu: false,
  inMenu: false,
  showLeftMenu: true,
};

export enum ViewConfigRoutes {
  IN_MENU = 'view.inMenu',
  IN_MANAGEMENT_MENU = 'view.inManagementMenu',
  SHOW_LEFT_MENU = 'view.showLeftMenu',
}